import { type FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useGetCurrentLeagueInfoQuery,
  useGetLeagueBoardQuery,
} from '@/api/queries/league';
import { useGetArenaOffersQuery } from '@/api/queries/shop';
import { GlobalLeagues } from '@/components/Leagues/GlobalLeagues/GlobalLeagues';
import LeagueBoard from '@/components/Leagues/LeagueBoard/LeagueBoard';
import { LeagueClaimRewardProvider } from '@/components/Modals/LeagueClaimReward/LeagueClaimRewardProvider';
import { Tab } from '@/components/Tabs/Tab';
import { Tabs } from '@/components/Tabs/Tabs';
import { TabsNavigation } from '@/components/Tabs/TabsNavigation';
import { showPopup } from '@/redux/reducers/shopReducer';
import { arenaShownPopupCheck } from '@/redux/selectors/leagues';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

const Leagues: FC = () => {
  const { t } = useTranslation();
  useGetArenaOffersQuery();
  useGetCurrentLeagueInfoQuery(undefined, { refetchOnMountOrArgChange: true });
  useGetLeagueBoardQuery();
  const arenaShownPopup = useAppSelector(arenaShownPopupCheck);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (arenaShownPopup) dispatch(showPopup(true));
  }, [arenaShownPopup]);

  const tabNavigationList = [
    {
      id: 'global',
      label: t('Global'),
    },
    {
      id: 'board',
      label: t('Leaderboard'),
    },
  ];

  return (
    <LeagueClaimRewardProvider>
      <main className={css.main}>
        <Tabs initActiveTab="global">
          <TabsNavigation variant="default" list={tabNavigationList} />
          <Tab className="flex-1" tabId="global">
            <GlobalLeagues />
          </Tab>
          <Tab tabId="board">
            <LeagueBoard />
          </Tab>
        </Tabs>
      </main>
    </LeagueClaimRewardProvider>
  );
};

export { Leagues };
